export default __webpack_public_path__ + "static/media/laundroBlueLogo.0e149f04.png";